export default __webpack_public_path__ + "static/CareerFeatureSix-0c7d62daa4bf3ffd1e13da91b0869e82.webp";